module.exports = "<a class=\"hidden-sm hidden-xs\" data-toggle=\"tooltip\" data-placement=\"right\"><i class=\"fa {{ $ctrl.icon }}\"></i></a>"


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/ui/tooltip/tooltip.html
// module id = 521
// module chunks = 0